import { render, staticRenderFns } from "./InfoPlayers.vue?vue&type=template&id=b67985a0&"
import script from "./InfoPlayers.vue?vue&type=script&lang=js&"
export * from "./InfoPlayers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports